import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft, ArrowRight, Trophy } from 'lucide-react';

const STEP_ORDER = [
  { id: 'people', href: '/people', label: 'Mensen' },
  { id: 'process', href: '/process', label: 'Organisatie' },
  { id: 'technology', href: '/technology', label: 'Systemen' },
];

const WizardNavButtons = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentIdx = STEP_ORDER.findIndex(s => s.href === location.pathname);
  if (currentIdx === -1) return null;

  const prevStep = currentIdx > 0 ? STEP_ORDER[currentIdx - 1] : null;
  const nextStep = currentIdx < STEP_ORDER.length - 1 ? STEP_ORDER[currentIdx + 1] : null;
  const isLastStep = currentIdx === STEP_ORDER.length - 1;

  return (
    <div className="mt-10 pt-6 border-t border-neutral-200" data-testid="wizard-nav-buttons">
      <div className="flex items-center justify-between">
        {prevStep ? (
          <Button
            variant="outline"
            className="border-neutral-300 text-neutral-700 hover:bg-neutral-50"
            onClick={() => navigate(prevStep.href)}
            data-testid="wizard-prev-btn"
          >
            <ArrowLeft className="h-4 w-4 mr-2" strokeWidth={1.5} />
            Vorige: {prevStep.label}
          </Button>
        ) : (
          <Button
            variant="outline"
            className="border-neutral-300 text-neutral-700 hover:bg-neutral-50"
            onClick={() => navigate('/assessment')}
            data-testid="wizard-prev-btn"
          >
            <ArrowLeft className="h-4 w-4 mr-2" strokeWidth={1.5} />
            Overzicht
          </Button>
        )}

        {isLastStep ? (
          <Button
            className="bg-black text-white hover:bg-neutral-800"
            onClick={() => navigate('/assessment')}
            data-testid="wizard-finish-btn"
          >
            <Trophy className="h-4 w-4 mr-2" strokeWidth={1.5} />
            Bekijk resultaten
          </Button>
        ) : nextStep ? (
          <Button
            className="bg-black text-white hover:bg-neutral-800"
            onClick={() => navigate(nextStep.href)}
            data-testid="wizard-next-btn"
          >
            Volgende: {nextStep.label}
            <ArrowRight className="h-4 w-4 ml-2" strokeWidth={1.5} />
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default WizardNavButtons;
